import React from "react";
import { Input, Select, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  findAllJobPostDto,
  PositionWithOpeningCount,
} from "../../../Interface/Index";

interface JobPostFilterMenuProps {
  filters: findAllJobPostDto;
  setFilters: React.Dispatch<React.SetStateAction<findAllJobPostDto>>;
  positionWithOpeningCount: PositionWithOpeningCount[];
}

const JobPostFilterMenu: React.FC<JobPostFilterMenuProps> = ({
  filters,
  setFilters,
  positionWithOpeningCount,
}) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters({ ...filters, searchQuery: e.target.value });
  };

  const handleDepartmentChange = (value: string | undefined) => {
    setFilters({ ...filters, position: value ? [value] : [] });
  };

  const filterOptions = positionWithOpeningCount.map((position) => ({
    label: `${position.position} (${position.openings})`,
    value: position.position,
  }));

  return (
    <div className="job-listing__filters">
      <div className="job-listing__filter-group job-listing__filter-group--role">
        <label className="job-listing__filter-label">
          What&apos;s your dream role?
        </label>
        <Input
          placeholder="e.g. Senior Frontend Engineer"
          value={filters.searchQuery || ""}
          onChange={handleSearch}
          prefix={<SearchOutlined className="job-listing__filter-icon" />}
          className="job-listing__filter-input"
          allowClear
        />
      </div>
      <div className="job-listing__filter-group">
        <label className="job-listing__filter-label">
          Choose your ideal position
        </label>
        <Select
          placeholder="Select a position"
          value={filters.position[0]}
          onChange={handleDepartmentChange}
          className="job-listing__filter-select"
          options={filterOptions}
          mode="multiple"
          allowClear
        />
      </div>
      <Button
        type="primary"
        className="job-listing__filter-btn"
        icon={<SearchOutlined />}
      >
        Find Jobs
      </Button>
    </div>
  );
};

export default JobPostFilterMenu;
